import React from 'react';
import { connect } from 'react-redux';
import { MainWrapper } from 'mm-ui-components';
import { getSecondaryHeader } from '../../store/secondaryHeader/secondaryHeader.selectors';
import { AppState } from '../../store/initialStateRegistration';

interface MainWrapperProps {
    isSecondaryHeaderEnabled: boolean
    noPadding?: boolean
    configThemeKey ?:string
    children: React.ReactNode
}

export const mapStateToProps = (state:AppState) => {
  return {
    isSecondaryHeaderEnabled: !!getSecondaryHeader(state),
  };
};

const MainWrapperComponent: React.FunctionComponent<MainWrapperProps> = (props) => {
  return <MainWrapper {...props} />;
};

export const MainWrapperConnected = connect(mapStateToProps)(MainWrapperComponent);
